import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import cookieConsent from './modules/cookieConsent';

const store = createStore({
    modules: {
        cookieConsent
    },
    state() {
        return {
            iframePath: null,
            language: navigator.language.replace("-", "_").toUpperCase(),
            currentMenu: {
                parent: '',
                current: '',
                detail: ''
            },
            menu: null,
            status: null,
            systemType: "PEGAPortal"
        };
    },
    mutations: {
        setIframePath(state, path) {
            state.iframePath = path;
        },
        setLanguage(state, lang){
            state.language = lang;
        },
        setCurrentMenu(state, item){
            state.currentMenu = item;
        },
        setMenu(state, item){
            state.menu = item;
        },
        setStatus(state, item){
            state.status = item;
        }
    },
    plugins: [ 
        createPersistedState({
            paths: ['language', 'menu', 'status', 'currentMenu'],  // Persist language + nav data to survive F5
            storage: localStorage
        }) 
    ],
    actions: {
        initCookieConsent({ dispatch }) {
            dispatch('cookieConsent/init', null, { root: true });
        }
    }
});

export default store;